import { jsx as _jsx } from "react/jsx-runtime";
import { animated, config, useTransition } from "@react-spring/web";
import { memo, useCallback, useEffect, useLayoutEffect, useRef } from "react";
import { PDFViewerOutlinePage } from "./components/PDFViewerOutlinePage/PDFViewerOutlinePage";
import { PDFViewerOutlineVirtualizedList } from "./components/PDFViewerOutlineVirtualizedList";
import { PDFViewerOutlineImagesCache } from "./utils/PDFViewerOutlineImagesCache";
export const PDF_OUTLINE_WIDTH = 192;
export const PDFViewerOutline = /*#__PURE__*/ memo((param)=>{
    let { isOpen, pdfPageCacheRef, pagesCount, currentPage, onPageClick, renderOutlinePageMenu } = param;
    const listRef = useRef(null);
    const pdfOutlineThumbnailsCacheRef = useRef();
    useLayoutEffect(()=>{
        pdfOutlineThumbnailsCacheRef.current = new PDFViewerOutlineImagesCache();
        return ()=>{
            var _pdfOutlineThumbnailsCacheRef_current;
            (_pdfOutlineThumbnailsCacheRef_current = pdfOutlineThumbnailsCacheRef.current) === null || _pdfOutlineThumbnailsCacheRef_current === void 0 ? void 0 : _pdfOutlineThumbnailsCacheRef_current.cleanup();
            pdfOutlineThumbnailsCacheRef.current = null;
        };
    }, []);
    const transitions = useTransition(isOpen, {
        from: {
            opacity: 0,
            x: -PDF_OUTLINE_WIDTH
        },
        enter: {
            opacity: 1,
            x: 0
        },
        leave: {
            opacity: 0,
            x: -PDF_OUTLINE_WIDTH
        },
        config: config.stiff
    });
    useEffect(()=>{
        var _listRef_current;
        (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.scrollToIndex(currentPage - 1);
    }, [
        currentPage
    ]);
    const renderOutlinePages = useCallback((param)=>{
        let { index } = param;
        const pageNumber = index + 1;
        return /*#__PURE__*/ _jsx(PDFViewerOutlinePage, {
            thumbnailCacheRef: pdfOutlineThumbnailsCacheRef,
            isSelected: currentPage === pageNumber,
            pageNumber: pageNumber,
            pdfPageCacheRef: pdfPageCacheRef,
            onPageClick: onPageClick,
            renderOutlinePageMenu: renderOutlinePageMenu
        });
    }, [
        currentPage,
        pdfPageCacheRef,
        onPageClick,
        renderOutlinePageMenu
    ]);
    return transitions((styles, item)=>item && /*#__PURE__*/ _jsx(animated.div, {
            className: "absolute left-0 top-0 flex h-full w-48 items-start justify-end bg-grey-12",
            style: styles,
            children: /*#__PURE__*/ _jsx("div", {
                className: "flex size-full bg-grey-1",
                style: {
                    boxShadow: "1px 0px 0px var(--colors-grey3)"
                },
                children: /*#__PURE__*/ _jsx(PDFViewerOutlineVirtualizedList, {
                    ref: listRef,
                    rowsCount: pagesCount,
                    children: renderOutlinePages
                })
            })
        }));
});
PDFViewerOutline.displayName = "PDFViewerOutline";
